// TODO: Remove after september 30 INT-519
const SEPARATOR = '~'

export function buildOauthState(source, hostname) {
  return `${source}${SEPARATOR}${hostname}`
}

export function parseOauthState(state) {
  const raw = String(state || '')
  const at = raw.indexOf(SEPARATOR)
  if (at === -1) return { source: null, hostname: raw }
  return { source: raw.slice(0, at), hostname: raw.slice(at + 1) }
}
